import {AxiosError} from 'axios';

import {Completable, EmployeeProductsDTO, KashableResponseDTO} from 'kashable-mobile-common';

import {errored, mapSucceeded} from '../utils/AxiosUtils';

import axios from './base';

const fetchProducts: () => Promise<Completable<EmployeeProductsDTO>> = () => {
    return axios
        .get<KashableResponseDTO<EmployeeProductsDTO>>('/secured/user/product')
        .then((res) => mapSucceeded(res, (d) => d.data))
        .catch((error: AxiosError<string>) => errored(error));
};

export {fetchProducts};
